import React from "react";
import { toast, ToastContainer } from "react-toastify";

interface ToastProps {
  type: "success" | "error" | "info" | "warning";
  message: string;
}

export const showToast = ({ type, message }: ToastProps) => {
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "info":
      toast.info(message);
      break;
    case "warning":
      toast.warning(message);
      break;
    default:
      toast(message);
  }
};


const ToastComponent: React.FC = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={6000}
      style={{
        minWidth: "500px",
        minHeight: "100px",
      }}
    />
  );
};

export default ToastComponent;
